timeString